import { useEffect, useRef, useCallback } from 'react'

// see https://reactjs.org/docs/hooks-faq.html#how-to-read-an-often-changing-value-from-usecallback
// with some modifications
export default function useEventCallback (fn, dependencies) {
    const ref = useRef(() => {
        throw new Error('Cannot call an event handler while rendering.')
    })

    useEffect(() => {
        ref.current = fn
    }, [fn, ...dependencies])

    return useCallback((...args) => {
        const fn = ref.current
        return fn(...args)
    }, [ref])
}
